<template>
  <div class="partner">
    <h2 class="title">合作伙伴</h2>
    <ul class="list">
      <li v-for="(item, index) in list" :key="index"><img :src="item.url" /></li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        { url: './assets/img/partner/01.png' },
        { url: './assets/img/partner/02.png' },
        { url: './assets/img/partner/03.png' },
        { url: './assets/img/partner/04.png' },
        { url: './assets/img/partner/05.png' }
      ]
    }
  }
}
</script>
<style>
.partner {
  clear: both;
  border-top: solid 1px #dadada;
  position: relative;
  margin: 0 auto;
}

.partner .title {
  margin: 30px 0;
  font-size: 24px;
  font-weight: normal;
  line-height: 2;
  text-align: center;
  color: #1e1e1e;
}

.partner .list {
  padding-bottom: 50px;
  font-size: 0;
  text-align: center;
}

.partner .list li {
  margin-left: 43.5px;
  display: inline-block;
  width: 170px;
  height: 50px;
}

.partner .list li:first-child {
  margin-left: 0;
}
</style>
